<template>
  <b-form>
    <b-row>
      <b-col>
        <b-form-group
          id="fieldsetUseWhenPatientPayIsNotSet"
          :label-cols="4"
          breakpoint="md"
          label="Use when patient pay is not set:"
          label-for="inputUseWhenPatientPayIsNotSet"
        >
          <b-form-radio-group
            id="inputUseWhenPatientPayIsNotSet"
            name="inputUseWhenPatientPayIsNotSet"
            v-validate="'required'"
            data-vv-as="Use when patient pay is not set"
            v-model="segment.use_when_patient_pay_not_set"
            :disabled="isReadonly"
            ref="useWhenPatientPayIsNotSet"
          >
            <b-form-radio :value="true">Yes</b-form-radio>
            <b-form-radio :value="false">No</b-form-radio>
          </b-form-radio-group>
          <span class="text-danger">{{ errors.first('inputUseWhenPatientPayIsNotSet') }}</span>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <p v-if="offerType==='patient_pay'">Out of Pocket Amount</p>
        <p v-if="offerType==='days_supply'">Days Supply</p>
      </b-col>
    </b-row>
    <b-row v-if="offerType==='patient_pay'">
      <b-col>
        <b-form-group
          id="fieldsetMinPatientPayAmount"
          :label-cols="4"
          breakpoint="md"
          label="Minimum*:"
          label-for="inputMinPatientPayAmount"
        >
          <b-form-input
            id="inputMinPatientPayAmount"
            name="inputMinPatientPayAmount"
            v-validate="'required_if:useWhenPatientPayIsNotSet,false|decimal:2'"
            type="number"
            v-model.number="segment.out_of_pocket_minimum_amt"
            data-vv-as="Minimum Out of Pocket Amount"
            placeholder="Minimum Out of Pocket Amount"
            :disabled="isReadonly"
          ></b-form-input>
          <span class="text-danger">{{ errors.first('inputMinPatientPayAmount') }}</span>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group
          id="fieldsetMaxPatientPayAmount"
          :label-cols="4"
          breakpoint="md"
          label="Maximum:"
          label-for="inputMaxPatientPayAmount"
        >
          <b-form-input
            id="inputMaxPatientPayAmount"
            name="inputMaxPatientPayAmount"
            v-validate="'decimal:2'"
            type="number"
            v-model.number="segment.out_of_pocket_maximum_amt"
            data-vv-as="Maximum Out of Pocket Amount"
            placeholder="Maximum Out of Pocket Amount"
            :disabled="isReadonly"
          ></b-form-input>
          <span class="text-danger">{{ errors.first('inputMaxPatientPayAmount') }}</span>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="offerType==='days_supply'">
      <b-col>
        <b-form-group
          id="fieldsetMinDaysSupply"
          :label-cols="4"
          breakpoint="md"
          label="Minimum*:"
          label-for="inputMinDaysSupply"
        >
          <b-form-input
            id="inputMinDaysSupply"
            name="inputMinDaysSupply"
            v-validate="'required|numeric'"
            type="number"
            v-model.number="segment.days_supply_minimum_amt"
            data-vv-as="Minimum Days Supply"
            placeholder="Minimum Days Supply"
            :disabled="isReadonly"
          ></b-form-input>
          <span class="text-danger">{{ errors.first('inputMinDaysSupply') }}</span>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group
          id="fieldsetMaxDaysSupply"
          :label-cols="4"
          breakpoint="md"
          label="Maximum:"
          label-for="inputMaxDaysSupply"
        >
          <b-form-input
            id="inputMaxDaysSupply"
            name="inputMaxDaysSupply"
            v-validate="'numeric'"
            type="number"
            v-model.number="segment.days_supply_maximum_amt"
            data-vv-as="Maximum Days Supply"
            placeholder="Maximum Days Supply"
            :disabled="isReadonly"
          ></b-form-input>
          <span class="text-danger">{{ errors.first('inputMaxDaysSupply') }}</span>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-row>
          <b-col>
            <b-form-group
              id="fieldsetShortText"
              :label-cols="4"
              breakpoint="md"
              label="Short Text*:"
              label-for="inputShortText"
            >
              <b-input-group>
                <b-form-textarea
                  id="inputShortText"
                  name="inputShortText"
                  v-validate="'required'"
                  type="text"
                  v-model="segment.offer_short_text"
                  data-vv-as="Short Text"
                  placeholder="Short text"
                  :disabled="isReadonly"
                  :rows="4"
                  ref="shortText"
                  @select="selChange('shortText')"
                ></b-form-textarea>
                <b-button
                  :hidden="isReadonly"
                  @click="openModal('offer_short_text')"
                >...</b-button>
                <span class="text-danger">{{ errors.first('inputShortText') }}</span>
              </b-input-group>
            </b-form-group>
            <b-modal
              title="Enter Url"
              ref="modalUrl"
              @ok="applyUrl"
            >
              <b-input
                id="inputUrlText"
                name="inputUrlText"
                v-model="inputUrl"
                type="text"
                data-vv-as="Url"
                v-validate="{ required: true, regex: /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/ }"
              ></b-input>
              <span class="text-danger">{{ errors.first('inputUrlText') }}</span>
            </b-modal>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              id="fieldsetShortPlainText"
              :label-cols="4"
              breakpoint="md"
              label="Short Plain Text*:"
              label-for="inputShortPlainText"
            >
              <b-form-textarea
                id="inputShortPlainText"
                name="inputShortPlainText"
                v-validate="'required'"
                type="text"
                v-model="segment.offer_short_plain_text"
                data-vv-as="Short Plain Text"
                placeholder="Short plain text"
                :disabled="isReadonly"
              ></b-form-textarea>
              <span class="text-danger">{{ errors.first('inputShortPlainText') }}</span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              id="fieldsetLongText"
              :label-cols="4"
              breakpoint="md"
              label="Long Text*:"
              label-for="inputLongText"
            >
              <b-input-group>
                <b-form-textarea
                  id="inputLongText"
                  name="inputLongText"
                  v-validate="'required'"
                  type="text"
                  v-model="segment.offer_long_text"
                  :rows="4"
                  data-vv-as="Long Text"
                  placeholder="Long text"
                  :disabled="isReadonly"
                  ref="longText"
                  @select="selChange('longText')"
                ></b-form-textarea>
                <b-button
                  :hidden="isReadonly"
                  @click="openModal('offer_long_text')"
                >...</b-button>
                <span class="text-danger">{{ errors.first('inputLongText') }}</span>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              id="fieldsetLongPlainText"
              :label-cols="4"
              breakpoint="md"
              label="Long Plain Text*:"
              label-for="inputLongPlainText"
            >
              <b-form-textarea
                id="inputLongPlainText"
                name="inputLongPlainText"
                v-validate="'required'"
                type="text"
                v-model="segment.offer_long_plain_text"
                :rows="4"
                data-vv-as="Long Plain Text"
                placeholder="Long plain text"
                :disabled="isReadonly"
              ></b-form-textarea>
              <span class="text-danger">{{ errors.first('inputLongPlainText') }}</span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              id="fieldsetCouponUrl"
              :label-cols="4"
              breakpoint="md"
              label="Coupon Url:"
              label-for="inputCouponUrl"
            >
              <b-form-textarea
                id="inputCouponUrl"
                name="inputCouponUrl"
                type="text"
                :rows="4"
                v-model="segment.coupon_url"
                v-validate="{ regex: /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/ }"
                data-vv-as="Coupon Url"
                placeholder="Coupon Url"
                :disabled="isReadonly"
              ></b-form-textarea>
              <span class="text-danger">{{ errors.first('inputCouponUrl') }}</span>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
      <b-col>
        <b-row>
          <b-col>
            <b-form-group
              id="fieldsetOfferAmount"
              :label-cols="4"
              breakpoint="md"
              label="Offer Amount:"
              label-for="inputOfferAmount"
            >
              <b-input-group prepend="$">
                <b-form-input
                  id="inputOfferAmount"
                  name="inputOfferAmount"
                  type="number"
                  v-model.number="segment.offer_amount"
                  data-vv-as="Offer Amount"
                  placeholder="Offer Amount"
                  :disabled="isReadonly"
                  step=".01"
                ></b-form-input>
              </b-input-group>
              <span class="text-danger">{{ errors.first('inputOfferAmount') }}</span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              id="fieldsetMaxCap"
              :label-cols="4"
              breakpoint="md"
              label="Max Cap:"
              label-for="inputMaxCap"
            >
              <b-input-group prepend="$">
                <b-form-input
                  id="inputMaxCap"
                  name="inputMaxCap"
                  type="number"
                  v-model.number="segment.max_cap"
                  data-vv-as="Max Cap"
                  placeholder="Max Cap"
                  step=".01"
                  :disabled="isReadonly"
                ></b-form-input>
              </b-input-group>
              <span class="text-danger">{{ errors.first('inputMaxCap') }}</span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              id="fieldsetBIN"
              :label-cols="4"
              breakpoint="md"
              label="BIN:"
              label-for="inputBIN"
              :disabled="isReadonly"
            >
              <b-form-input
                id="inputBIN"
                name="inputBIN"
                v-validate="'max:50'"
                type="text"
                v-model="segment.bin"
                data-vv-as="BIN"
                placeholder="BIN"
                :disabled="isReadonly"
              ></b-form-input>
              <span class="text-danger">{{ errors.first('inputBIN') }}</span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              id="fieldsetPCN"
              :label-cols="4"
              breakpoint="md"
              label="PCN:"
              label-for="inputPCN"
            >
              <b-form-input
                id="inputPCN"
                name="inputPCN"
                v-validate="'max:50'"
                type="text"
                v-model="segment.pcn"
                data-vv-as="PCN"
                placeholder="PCN"
                :disabled="isReadonly"
              ></b-form-input>
              <span class="text-danger">{{ errors.first('inputPCN') }}</span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              id="fieldsetGroupId"
              :label-cols="4"
              breakpoint="md"
              label="Group Id:"
              label-for="inputGroupId"
            >
              <b-form-input
                id="inputGroupId"
                name="inputGroupId"
                v-validate="'max:50'"
                type="text"
                v-model="segment.group_id"
                data-vv-as="Group Id"
                placeholder="Group Id"
                :disabled="isReadonly"
              ></b-form-input>
              <span class="text-danger">{{ errors.first('inputGroupId') }}</span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              id="fieldsetMemberId"
              :label-cols="4"
              breakpoint="md"
              label="Member Id:"
              label-for="inputMemberId"
            >
              <b-form-input
                id="inputMemberId"
                name="inputMemberId"
                v-validate="'max:50'"
                type="text"
                v-model="segment.member_id"
                data-vv-as="Member Id"
                placeholder="Member Id"
                :disabled="isReadonly"
              ></b-form-input>
              <span class="text-danger">{{ errors.first('inputMemberId') }}</span>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
  import VueQueryBuilder from "vue-query-builder";
  import Vue from 'vue';

  // @ts-check
  export default {
    name: "VOfferSegmentItem",
    components: { VueQueryBuilder },
    props: {
      segment: {
        required: true,
        type: Object
      },
      offerType: {
        required: true,
        type: String
      },
      states: {
        required: true,
        type: Object
      },
      isReadonly: {
        required: true,
        type: Boolean
      }
    },
    methods: {
      selChange(control) {
        this.selectionStart = this.$refs[control].selectionStart;
        this.selectionEnd = this.$refs[control].selectionEnd;
      },
      openModal(field) {
        this.target = field;
        this.inputUrl = "";
        this.$refs.modalUrl.$validator.reset();
        this.$refs.modalUrl.show();
      },
      applyUrl(evt) {
        evt.preventDefault();
        this.$validator.validate('inputUrlText', this.inputUrl)
          .then(isValid => {
            if (!isValid) {
              return;
            }

            let text = "";
            text = this.segment[this.target].substring(0, this.selectionStart);
            if (this.selectionStart < this.selectionEnd) {
              text = text + "<a href='" + this.inputUrl + "'>" + this.segment[this.target].substring(this.selectionStart, this.selectionEnd) + "</a>";
            } else {
              text = text + "<a href='" + this.inputUrl + "'></a>";
            }
            text = text + this.segment[this.target].substring(this.selectionEnd);
            Vue.set(this.segment, this.target, text);
            this.selectionStart = 0;
            this.selectionEnd = 0;
            this.target = "";
            this.$refs.modalUrl.hide();
          });
      }
    },
    data() {
      return {
        selectionStart: 0,
        selectionEnd: 0,
        target: "",
        inputUrl: "",
        rules: [
          {
            type: "numeric",
            id: "patientPayAmount",
            label: "Patient Pay Amount"
          },
          {
            type: "numeric",
            id: "daysSupply",
            label: "Days Supply"
          },
          {
            type: "numeric",
            id: "patientAge",
            label: "Age"
          },
          {
            type: "radio",
            id: "patientGender",
            label: "Gender",
            choices: [
              { label: "Male", value: "M" },
              { label: "Female", value: "F" },
              { label: "Unknown", value: "U" }
            ]
          },
          {
            type: "select",
            id: "patientStateCode",
            label: "Patient State",
            choices: Object.keys(this.states).map(item => {
              return { label: item, value: this.states[item] };
            })
          },
          {
            type: "text",
            id: "patientZipCode",
            label: "Patient Zip Code"
          }
        ]
      };
    }
  };
</script>

<style lang="scss">
  #inputLongText,
  #inputLongPlainText {
    height: 85px;
  }
</style>



// WEBPACK FOOTER //
// src/components/VOfferSegmentItem.vue